import { gql } from '@apollo/client';

export const createIndividualFromSessionQuery = gql`
  mutation createIndividualFromSession(
    $disLangcode: String!
    $auth0Id: String
  ) {
    createIndividualFromSession(langcode: $disLangcode, auth0Id: $auth0Id) {
      individualId
      MemberID
      USERGUID
      emailId
    }
  }
`;
